// extracted by mini-css-extract-plugin
export default {"label":"Label__label___aJ7Cb","muted":"Label__muted___2G2Rk"};